<template>
  <div class='tw-w-full tw-bg-gray-50 ResultadosCard'>
      <Card class='p-shadow-5 tw-h-full'>
          <template #content>
                <div class="tw-flex tw-flex-col tw-flex-1 tw-gap-3 tw-h-full">
                    <div class='tw-flex tw-flex-col md:tw-flex-row tw-gap-3'>
                        <div class='tw-w-full md:tw-text-left! tw-flex tw-flex-col tw-items-center md:tw-items-start tw-justify-center'>
                            <div  class='tw-flex tw-flex-col tw-gap-1'>
                                <div>
                                    <span style='text-transform:capitalize;' class='tw-font-bold tw-text-lg'>{{nombreEstudio}} </span>
                                </div>
                                <div v-if='practica' class='tw-flex tw-gap-1'>
                                    <span style='text-transform:capitalize;' class='tw-font-medium tw-text-sm'>{{practica?.descripcion?.toLowerCase()}}</span>
                                </div>
                                <div>
                                    <span style='color:var(--primary-color);' class='tw-font-medium tw-text-sm'>{{fecha}}</span>
                                </div>
                            </div>
                        </div>
                        <div class='tw-mx-auto md:tw-ml-auto  md:tw-flex-col tw-flex-wrap tw-flex tw-gap-2 tw-text-sm'>
                            <div v-if='hasInforme' @click='$emit("ver")' class='tw-max-w-min md:tw-max-w-none tw-shadow-sm tw-flex tw-gap-3 tw-items-center tw-justify-center tw-cursor-pointer tw-select-none tw-w-full tw-px-4 tw-py-2  tw-border tw-border-gray-400 tw-rounded'>
                                <span style='color:var(--primary-color); white-space:nowrap;' class='tw-mx-auto tw-text-center tw-font-semibold'>{{ isPac || isExterno ? 'Descargar Inf.' : 'Descargar PDF' }}</span>
                                <i style='font-size:1.5em; color:var(--primary-color);' class='pi pi-file-pdf tw-ml-auto'></i>
                            </div>
                            <div v-if='isPac && verImagenesEstudios' @click='$emit("visualizar")' class='tw-max-w-min md:tw-max-w-none tw-shadow-sm tw-flex tw-items-center tw-justify-center tw-gap-3 tw-cursor-pointer tw-select-none tw-w-full tw-border tw-border-gray-400 tw-px-4 tw-py-2 tw-rounded'>
                                <span style='color:var(--primary-color);white-space:nowrap;' class='tw-mx-auto tw-text-center tw-font-semibold'>Ver Imagen</span>
                                <i style='font-size:1.5em; color:var(--primary-color);' class='pi pi-image tw-ml-auto'></i>
                            </div>
                        </div>
                    </div>
                    <div class="tw-w-full tw-mt-auto tw--mb-6 tw-flex tw-flex-col tw-gap-1">
                        <hr>
                        <div class="tw-w-full tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-sm tw-text-indigo-500 tw-cursor-pointer">
                            <p v-for='(item, index) in extraItems' :key='item' @click='item.command' class='tw-select-none tw-flex tw-gap-2 tw-items-center' :class='{"tw-border-l tw-border-indigo-500 tw-pl-2":index }'>
                                <a>{{item.label}}</a>
                                <i :class='[item.icon,"tw-text-xs tw-font-semibold"]'></i>
                            </p>
                        </div>
                    </div>
                </div>
          </template>
      </Card>
      <Dialog :closable="true"  :modal="true" appendTo="self" header="Información" v-model:visible="showInfo">
            <resultado-info v-if='showInfo' :id='datos?._id'></resultado-info>
            <template #footer>
                <div class="tw-w-full">
                    <Button @click='showInfo = false'>Aceptar</Button>
                </div>
            </template>
        </Dialog>
  </div>

</template>

<script lang='ts'>
import { computed, defineComponent, ref, toRef, toRefs, watch } from 'vue'
import { useStore } from 'vuex';
import ResultadoInfo from '@/components/ResultadoInfo.vue'

import moment from 'moment';

export default defineComponent({
    props:['datos'],
    components:{
        ResultadoInfo,
    },
    setup(props, {emit}){
        const store = useStore()
        const es = moment(props.datos.datos.fecha).locale('es')
        const fecha = ref(es.format('dddd DD \\d\\e MMM \\d\\e\\l YYYY'))
        const showInfo = ref(false)

        const extraItems = computed(() => [
            ...((isPac.value || isExterno.value) ? [
                {
                label: 'Mas Info',
                icon: 'pi pi-plus',
                command: () => {
                    showInfo.value = true
                }
            },
            ] : []),
            ...(hasInforme.value && canShare.value ? [
                {
                label: 'Compartir',
                icon: 'pi pi-share-alt',
                command: () => {
                    emit('compartir')
                }
            }] : []),
        ])

        const isPac = computed(() => {
            const tipos = ['PAC']
            return tipos.includes(props.datos.tipo)
        })

        const isExterno = computed(() => {
            const tipos = ['LABFHIR']
            return tipos.includes(props.datos.tipo)
        })

        const nombreEstudio = computed(() => {
            return props.datos.datos?.nombre?.toLowerCase() || 'Resultado De Laboratorio'
        })

        const hasFile = computed(() => {
            return !!props.datos.file 
        })

        const canShare = computed(() => {
            return !!navigator.canShare
        })


        const verImagenesEstudios = computed(() => store?.state?.configuracionPortal?.ver_imagenes_estudios)
        
        const hasInforme = computed(() => {
            let hasInforme = !isPac.value && !isExterno.value
            return hasInforme || hasFile.value
        })

        const practica = computed(() => {
            return props.datos.datos?.prestaciones?.[0] || props.datos.datos?.practica || []
        })

        return {
            fecha,
            isPac,
            verImagenesEstudios,
            nombreEstudio,
            isExterno,
            hasInforme,
            showInfo,
            extraItems,
            practica,
        }
    }
})
</script>

<style>
.ResultadosCard .p-component .p-card-body .p-card-content, .ResultadosCard .p-component .p-card-body {
    height: 100%;
}
</style>